import React from 'react';
import { range } from './Util';


export default function SkeletonTableRows(props) {
    const {
        columns,
        rowKey,
        totalRows = 10,
    } = props;

    return range(0, totalRows)
        .map((i) => {
            const row = {
                [rowKey]: `${i}`,
                isSkeletonRow: true,
            };
        
            columns.forEach(c => {
                row[c.name] = (
                    <div
                        className="skeleton-table-row"
                        style={{ width: '100%'}}
                    >
                        &nbsp;
                    </div>
                )
            });
        
            return row;
        });
};



// WEBPACK FOOTER //
// ./src/helpers/SkeletonTableRows.js